import { combineReducers } from "redux";
import agencies from "./agency/agenciesSlice";

export default combineReducers({
	agencies,
});
